export const isFlexEmulatorAvailable = (): boolean => import.meta.env.DEV;
